// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ezk5H","newExpiryDate":"styles_newExpiryDate__2VxBy","footer":"styles_footer__7LbHt"};